import { useState } from 'react'
import { Icon } from './Icon.js'

const KEY = 'hub.installHint.dismissed'

/** iPhone/iPad in Safari, not yet opened from the home screen. */
function shouldShow(): boolean {
  try {
    if (localStorage.getItem(KEY)) return false
  } catch {
    return false
  }
  const standalone = window.matchMedia('(display-mode: standalone)').matches || (navigator as { standalone?: boolean }).standalone === true
  const ios = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  return ios && !standalone
}

/** Like pebro Sales: the hub is meant to live on the home screen, where it stays signed in. */
export function InstallHint(): JSX.Element | null {
  const [show, setShow] = useState(shouldShow)
  if (!show) return null
  return (
    <div className="card flex items-start gap-3">
      <img src="/icon-192.png" alt="" className="h-11 w-11 shrink-0 rounded-[22%]" />
      <div className="min-w-0 flex-1">
        <p className="text-callout font-semibold">Als App auf den Home-Bildschirm</p>
        <p className="mt-0.5 text-small text-label2/65">
          In Safari auf <span className="font-medium text-label">Teilen</span> tippen, dann{' '}
          <span className="font-medium text-label">„Zum Home-Bildschirm“</span>. Dort bleibst du angemeldet.
        </p>
      </div>
      <button
        type="button"
        aria-label="Hinweis ausblenden"
        className="grid h-8 w-8 shrink-0 place-items-center rounded-full text-label2/50 hover:bg-fill/[0.1]"
        onClick={() => {
          try {
            localStorage.setItem(KEY, '1')
          } catch {
            // Private mode: hidden for this visit only.
          }
          setShow(false)
        }}
      >
        <Icon name="close" size={16} />
      </button>
    </div>
  )
}
